/**
 * @generated SignedSource<<6d4267b364f65e41f0d40c30c4d55425>>
 * @relayHash 1ffcfc966aabca86138e5b7e75dbf24c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8edc365c60e91cff469d7a04fcff156a098500471b0dee42955ba86049e7243

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type GoalPanelQuery$variables = {
  ari: string;
  capabilitiesContainerId: string;
  queryContext?: string | null;
};
export type GoalPanelQuery$data = {
  readonly goals_byId: Result<{
    readonly id: string;
    readonly key: string;
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalCustomFields" | "GoalFocusAreas" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatusField" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "GoalUpdateComposerCreate" | "ParentGoal" | "SubGoals">;
  } | null, unknown>;
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoalPanelTabs">;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "capabilitiesContainerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "picture"
},
v6 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "ari"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "url"
},
v9 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v13 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v14 = {
  "kind": "ScalarField",
  "name": "canManagePeriodicMetricTargets"
},
v15 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedGoals"
},
v16 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v17 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v18 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v19 = [
  (v7/*: any*/),
  (v3/*: any*/)
],
v20 = [
  (v3/*: any*/)
],
v21 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v23 = {
  "concreteType": "TownsquareGoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "value"
},
v25 = [
  (v24/*: any*/)
],
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v27 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v25/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v26/*: any*/)
  ]
},
v28 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "kind"
},
v30 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v25/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v26/*: any*/)
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "score"
},
v32 = [
  (v24/*: any*/),
  (v31/*: any*/)
],
v33 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v34 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v35 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v36 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v35/*: any*/)
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v38 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v39 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v40 = {
  "kind": "ScalarField",
  "name": "end"
},
v41 = {
  "kind": "ScalarField",
  "name": "start"
},
v42 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v43 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v40/*: any*/)
  ]
},
v44 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/)
  ]
},
v45 = [
  (v24/*: any*/),
  (v3/*: any*/)
],
v46 = {
  "kind": "ScalarField",
  "name": "variance"
},
v47 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v45/*: any*/)
    },
    (v46/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "type"
},
v49 = {
  "kind": "ScalarField",
  "name": "subType"
},
v50 = {
  "kind": "ScalarField",
  "name": "archived"
},
v51 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v52 = {
  "kind": "ScalarField",
  "name": "source"
},
v53 = {
  "kind": "ScalarField",
  "name": "time"
},
v54 = [
  (v53/*: any*/),
  (v3/*: any*/),
  (v24/*: any*/)
],
v55 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v56 = [
  (v55/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v57 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v32/*: any*/)
},
v58 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v59 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v60 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v61 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v59/*: any*/),
    (v60/*: any*/)
  ]
},
v62 = {
  "args": (v56/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v24/*: any*/),
            (v53/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "TownsquareGoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v39/*: any*/),
                        {
                          "concreteType": "TownsquareGoal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": (v20/*: any*/)
                        },
                        (v57/*: any*/),
                        (v3/*: any*/)
                      ]
                    }
                  ],
                  "type": "TownsquareFromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v39/*: any*/)
                  ],
                  "type": "TownsquareFromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "TownsquareFromMetricUpdate"
                }
              ]
            },
            (v22/*: any*/),
            (v11/*: any*/)
          ]
        },
        (v58/*: any*/)
      ]
    },
    (v61/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
},
v63 = {
  "args": (v56/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v64 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v45/*: any*/)
},
v65 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v66 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v67 = [
  (v53/*: any*/),
  (v3/*: any*/)
],
v68 = {
  "args": (v56/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v67/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareTargetDateRange",
                  "kind": "LinkedField",
                  "name": "dateRange",
                  "plural": false,
                  "selections": [
                    (v40/*: any*/)
                  ]
                }
              ]
            },
            (v24/*: any*/)
          ]
        },
        (v46/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
},
v69 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v70 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v69/*: any*/),
    (v48/*: any*/)
  ]
},
v71 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v3/*: any*/),
    (v28/*: any*/)
  ]
},
v72 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v67/*: any*/)
},
v73 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v48/*: any*/),
                (v49/*: any*/),
                (v50/*: any*/),
                (v51/*: any*/),
                (v52/*: any*/),
                (v72/*: any*/)
              ]
            },
            (v64/*: any*/),
            (v65/*: any*/),
            (v66/*: any*/)
          ]
        }
      ]
    }
  ]
},
v74 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v32/*: any*/)
},
v75 = [
  (v43/*: any*/)
],
v76 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v75/*: any*/)
},
v77 = [
  (v11/*: any*/),
  (v35/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v3/*: any*/)
],
v78 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v77/*: any*/)
},
v79 = {
  "kind": "ScalarField",
  "name": "label"
},
v80 = {
  "kind": "ScalarField",
  "name": "summary"
},
v81 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v77/*: any*/)
},
v82 = {
  "kind": "ScalarField",
  "name": "description"
},
v83 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v84 = [
  (v11/*: any*/),
  (v5/*: any*/),
  (v4/*: any*/),
  (v35/*: any*/),
  (v3/*: any*/)
],
v85 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v84/*: any*/)
},
v86 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v84/*: any*/)
},
v87 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v88 = [
  (v39/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v24/*: any*/),
      (v31/*: any*/),
      (v79/*: any*/)
    ]
  },
  (v80/*: any*/),
  (v81/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v80/*: any*/),
              (v82/*: any*/),
              (v50/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v3/*: any*/),
              (v80/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v85/*: any*/),
              (v86/*: any*/),
              (v39/*: any*/),
              (v87/*: any*/)
            ]
          }
        ]
      },
      (v22/*: any*/)
    ]
  },
  (v3/*: any*/)
],
v89 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v88/*: any*/)
},
v90 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v91 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v92 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v93 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareGoalUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v90/*: any*/),
            (v91/*: any*/),
            (v80/*: any*/),
            (v92/*: any*/),
            (v39/*: any*/),
            (v3/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "updates(first:1)"
},
v94 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v95 = [
  (v94/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v96 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v97 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v25/*: any*/)
},
v98 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v75/*: any*/)
},
v99 = [
  (v11/*: any*/),
  (v3/*: any*/)
],
v100 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v99/*: any*/)
  }
],
v101 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v99/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": (v100/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v102 = {
  "args": (v95/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
},
v103 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v104 = [
  (v48/*: any*/),
  (v69/*: any*/)
],
v105 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v104/*: any*/)
},
v106 = {
  "concreteType": "TownsquareGoalAppCapabilities",
  "kind": "LinkedField",
  "name": "apps",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ]
},
v107 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v82/*: any*/)
],
v108 = [
  (v55/*: any*/)
],
v109 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v110 = [
  (v24/*: any*/),
  (v53/*: any*/),
  (v3/*: any*/)
],
v111 = [
  (v79/*: any*/),
  (v43/*: any*/)
],
v112 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v4/*: any*/),
                (v3/*: any*/),
                (v35/*: any*/),
                (v5/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v92/*: any*/),
            (v39/*: any*/)
          ]
        }
      ]
    },
    (v22/*: any*/)
  ]
},
v113 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v80/*: any*/),
      (v82/*: any*/),
      (v85/*: any*/),
      (v86/*: any*/),
      (v39/*: any*/),
      (v87/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v114 = [
  (v94/*: any*/),
  (v9/*: any*/)
],
v115 = [
  {
    "concreteType": "TownsquareHighlightEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v100/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "CatchField",
        "field": {
          "args": (v6/*: any*/),
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goals_byId",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "args": (v10/*: any*/),
              "kind": "FragmentSpread",
              "name": "GoalFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalPanelTitleField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalType"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalMetrics"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ParentGoal"
            },
            {
              "kind": "FragmentSpread",
              "name": "SubGoals"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalActions"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTeams"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalCustomFields"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalUpdateComposerCreate"
            }
          ]
        },
        "to": "RESULT"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          },
          {
            "kind": "Variable",
            "name": "capabilitiesContainerId",
            "variableName": "capabilitiesContainerId"
          },
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalPanelTabs"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v6/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  },
                  (v12/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              (v13/*: any*/),
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v12/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              (v15/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canAddWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canAddTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              },
              (v16/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canWatchGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedProjects"
              },
              (v17/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddJiraAlignItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveJiraAlignItems"
              }
            ]
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v4/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v19/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v19/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v21/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              (v22/*: any*/)
            ]
          },
          (v23/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v3/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v3/*: any*/),
                  (v27/*: any*/),
                  (v30/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              (v31/*: any*/),
              {
                "concreteType": "TownsquareCompletionGoalState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": (v32/*: any*/)
              }
            ]
          },
          (v33/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v34/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "targetDate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTargetDateRange",
                "kind": "LinkedField",
                "name": "dateRange",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  (v41/*: any*/)
                ]
              },
              (v42/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v44/*: any*/),
                                  (v24/*: any*/),
                                  (v11/*: any*/),
                                  (v47/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v3/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "latestValue",
                            "plural": false,
                            "selections": (v54/*: any*/)
                          },
                          (v22/*: any*/),
                          (v62/*: any*/),
                          (v63/*: any*/)
                        ]
                      },
                      (v64/*: any*/),
                      (v65/*: any*/),
                      (v66/*: any*/),
                      (v68/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              },
              (v22/*: any*/)
            ]
          },
          (v70/*: any*/),
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v70/*: any*/),
                      (v3/*: any*/),
                      (v71/*: any*/),
                      (v34/*: any*/),
                      (v73/*: any*/),
                      (v8/*: any*/),
                      (v74/*: any*/),
                      (v4/*: any*/),
                      (v37/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v17/*: any*/)
                        ]
                      },
                      (v50/*: any*/),
                      (v33/*: any*/),
                      (v76/*: any*/),
                      (v78/*: any*/),
                      (v89/*: any*/),
                      (v93/*: any*/),
                      {
                        "args": (v95/*: any*/),
                        "concreteType": "TownsquareProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v34/*: any*/),
                                  (v4/*: any*/),
                                  (v8/*: any*/),
                                  (v96/*: any*/),
                                  (v97/*: any*/),
                                  (v98/*: any*/),
                                  (v36/*: any*/),
                                  (v11/*: any*/),
                                  (v101/*: any*/)
                                ]
                              },
                              (v58/*: any*/),
                              (v11/*: any*/)
                            ]
                          },
                          (v61/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      },
                      (v102/*: any*/)
                    ]
                  }
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "args": (v103/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v105/*: any*/),
                      (v50/*: any*/),
                      (v3/*: any*/),
                      (v34/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v30/*: any*/),
                          (v3/*: any*/),
                          (v28/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      (v74/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v51/*: any*/),
                                      (v52/*: any*/),
                                      (v72/*: any*/),
                                      (v62/*: any*/),
                                      (v63/*: any*/)
                                    ]
                                  },
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v44/*: any*/),
                                              (v24/*: any*/),
                                              (v47/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v68/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/),
                      (v33/*: any*/),
                      (v76/*: any*/),
                      (v78/*: any*/),
                      (v89/*: any*/),
                      (v18/*: any*/),
                      (v93/*: any*/),
                      (v23/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v13/*: any*/),
                          (v106/*: any*/)
                        ]
                      },
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/)
                    ]
                  },
                  (v11/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              (v106/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v3/*: any*/),
              (v70/*: any*/),
              (v73/*: any*/),
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": (v25/*: any*/)
              },
              (v4/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  (v3/*: any*/)
                ]
              },
              (v37/*: any*/),
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v15/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v82/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v60/*: any*/),
                  (v59/*: any*/)
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareSlackConnectionConnection",
            "kind": "LinkedField",
            "name": "slackChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareSlackConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareSlackConnection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareSlackChannel",
                        "kind": "LinkedField",
                        "name": "channel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "numMembers"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
            "kind": "LinkedField",
            "name": "msteamsChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v95/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "args": (v103/*: any*/),
                        "concreteType": "TownsquareTeamConnection",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareTeamEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v20/*: any*/)
                              }
                            ]
                          }
                        ],
                        "storageKey": "teams(first:50)"
                      },
                      (v11/*: any*/),
                      (v97/*: any*/),
                      (v36/*: any*/),
                      (v101/*: any*/),
                      {
                        "concreteType": "TownsquareProjectUpdate",
                        "kind": "LinkedField",
                        "name": "latestUserUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectPhaseDetails",
                            "kind": "LinkedField",
                            "name": "newPhase",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "_id",
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          },
                          (v3/*: any*/)
                        ]
                      },
                      (v34/*: any*/),
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v96/*: any*/),
                      (v98/*: any*/)
                    ]
                  },
                  (v11/*: any*/),
                  (v58/*: any*/)
                ]
              },
              (v61/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          (v102/*: any*/),
          {
            "concreteType": "TownsquareGoalTeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      }
                    ]
                  }
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v107/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v22/*: any*/)
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v107/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v22/*: any*/)
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v107/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "args": (v108/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isUser"
                                      },
                                      (v4/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  },
                                  (v58/*: any*/)
                                ]
                              },
                              (v61/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v108/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v22/*: any*/)
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v82/*: any*/),
                                  {
                                    "args": (v108/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v24/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "args": (v108/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v11/*: any*/)
                                    ]
                                  },
                                  (v58/*: any*/)
                                ]
                              },
                              (v61/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v108/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v22/*: any*/)
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v50/*: any*/),
          {
            "args": (v109/*: any*/),
            "concreteType": "TownsquareGoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v80/*: any*/),
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v80/*: any*/),
                                  (v82/*: any*/),
                                  (v3/*: any*/),
                                  (v50/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/),
                      (v39/*: any*/),
                      (v90/*: any*/),
                      (v91/*: any*/),
                      (v57/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v80/*: any*/),
                                  (v82/*: any*/),
                                  (v11/*: any*/),
                                  (v3/*: any*/),
                                  (v83/*: any*/),
                                  (v85/*: any*/),
                                  (v86/*: any*/),
                                  (v39/*: any*/),
                                  (v87/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v22/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v52/*: any*/),
                                      (v72/*: any*/),
                                      {
                                        "args": [
                                          (v55/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v110/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v110/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v54/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v50/*: any*/),
                                          (v4/*: any*/),
                                          (v48/*: any*/),
                                          (v49/*: any*/),
                                          (v51/*: any*/),
                                          (v52/*: any*/),
                                          (v72/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v41/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v24/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v3/*: any*/),
                                      (v65/*: any*/),
                                      (v66/*: any*/),
                                      (v64/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v3/*: any*/),
                          (v33/*: any*/),
                          (v50/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v30/*: any*/),
                                  (v3/*: any*/)
                                ]
                              },
                              (v3/*: any*/)
                            ]
                          },
                          (v105/*: any*/),
                          {
                            "args": (v103/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v50/*: any*/),
                                      (v70/*: any*/),
                                      (v73/*: any*/),
                                      (v8/*: any*/),
                                      (v33/*: any*/),
                                      (v76/*: any*/),
                                      (v78/*: any*/),
                                      (v89/*: any*/),
                                      (v18/*: any*/),
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v30/*: any*/),
                                          (v28/*: any*/),
                                          (v3/*: any*/)
                                        ]
                                      },
                                      (v74/*: any*/),
                                      (v93/*: any*/)
                                    ]
                                  },
                                  (v11/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v50/*: any*/),
                                      (v70/*: any*/),
                                      (v71/*: any*/),
                                      (v73/*: any*/),
                                      (v8/*: any*/),
                                      (v33/*: any*/),
                                      (v76/*: any*/),
                                      (v78/*: any*/),
                                      (v89/*: any*/),
                                      (v34/*: any*/),
                                      (v74/*: any*/),
                                      (v93/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                              }
                            ],
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v80/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v80/*: any*/),
                                                  (v82/*: any*/),
                                                  (v3/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          }
                        ]
                      },
                      (v81/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v111/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v104/*: any*/)
                      },
                      {
                        "args": (v103/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v69/*: any*/)
                                    ]
                                  },
                                  (v3/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v88/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v105/*: any*/),
                                  (v73/*: any*/),
                                  (v8/*: any*/),
                                  (v33/*: any*/),
                                  (v76/*: any*/),
                                  (v78/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v35/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      (v92/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v35/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v20/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v20/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v112/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v32/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v111/*: any*/)
                      }
                    ]
                  },
                  (v58/*: any*/)
                ]
              },
              (v61/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": "updates(first:20)"
          },
          {
            "args": (v109/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "concreteType": "TownsquareGoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v67/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v3/*: any*/)
            ]
          },
          (v82/*: any*/),
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          (v112/*: any*/),
          {
            "kind": "ScalarField",
            "name": "updateStreak"
          },
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "isWatching"
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v113/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v113/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v113/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "args": (v114/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "workItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v80/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v21/*: any*/)
                    ]
                  },
                  (v58/*: any*/),
                  (v3/*: any*/)
                ]
              },
              (v61/*: any*/),
              (v22/*: any*/)
            ]
          },
          {
            "args": (v114/*: any*/),
            "filters": [
              "queryContext"
            ],
            "handle": "connection",
            "key": "GoalContentJira_workItems",
            "kind": "LinkedHandle",
            "name": "workItems"
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectName"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "mercuryProjectStatus",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mercuryName"
                              },
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryTargetDateEnd"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectUrl"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "mercuryProjectOwner",
                            "plural": false,
                            "selections": (v77/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "externalOwner",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "firstName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastName"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAlignAggProject"
                      },
                      (v21/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v99/*: any*/)
              }
            ]
          },
          {
            "alias": "learningsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "LEARNING"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v115/*: any*/),
            "storageKey": "highlights(type:\"LEARNING\")"
          },
          {
            "alias": "risksHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "RISK"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v115/*: any*/),
            "storageKey": "highlights(type:\"RISK\")"
          },
          {
            "alias": "decisionsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "DECISION"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v115/*: any*/),
            "storageKey": "highlights(type:\"DECISION\")"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "capabilitiesContainerId"
          }
        ],
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b8edc365c60e91cff469d7a04fcff156a098500471b0dee42955ba86049e7243",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a5f51fa89669af750f2ec6dc9462ebb0";

export default node;
